import * as Spinner from "react-spinners";



export default function Loader(props){
    return(
        <div style={{backgroundColor:"#FFF",position:"absolute",zIndex:10000,top:0,left:0,right:0,bottom:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Spinner.RingLoader
                color={"#00b3d6"}
                loading={true}
                cssOverride={{}}
                aria-label="Loading Spinner"
                data-testid="loader"
                speedMultiplier={3}
            />
        </div>
    )
}